import { cva } from '@/styled-system/css';

export const propertyCardBadgeRecipe = cva({
  base: {
    borderRadius: 'PropertyCard.Badge',
    padding: '{spacing.PropertyCard.Badge.padding.vert} {spacing.PropertyCard.Badge.padding.horz}',
    textStyle: 'body-xs-bold',
  },
  variants: {
    tone: {
      buyAbility: {
        backgroundColor: 'PropertyCard.Badge.buyAbility.bg',
        color: 'PropertyCard.Badge.buyAbility.label',
      },
      default: {
        backgroundColor: 'PropertyCard.Badge.flex.bg',
        color: 'PropertyCard.Badge.flex.label',
      },
      neutral: {
        backgroundColor: 'PropertyCard.Badge.neutral.bg',
        color: 'PropertyCard.Badge.neutral.label',
      },
      notify: {
        backgroundColor: 'PropertyCard.Badge.notify.bg',
        color: 'PropertyCard.Badge.notify.label',
      },
      zillow: {
        backgroundColor: 'PropertyCard.Badge.brand.bg',
        color: 'PropertyCard.Badge.brand.label',
      },
    },
  },
});
